document.addEventListener("click", function(e) {

    if (e.target.classList.contains("collection-desc-toggle")) {

      var wrap = e.target.closest(".collection-desc-wrapper");
      var contentBox = wrap.querySelector(".collection-desc-content");

      contentBox.classList.toggle("expanded");

      if (contentBox.classList.contains("expanded")) {
        e.target.textContent = "Read less";
      } else {
        e.target.textContent = "Read more";
      }
    }

  });